/**
 * /
 * @author xujw 2017-01-06
 * @param  vue 工具类
 * @return 返回一个包含工具类的对象
 */

export default {
    install: function (Vue) {
        Vue.prototype.$tool = {
            //*   1、timeChange(time,type)时间戳转换成 yyyy-mm-dd hh:mm:ss type为1时中间换行 0不换行
            DataChange: function (obj) {
                let params = new URLSearchParams();
                for (let i in obj) {
                    params.append(i, obj[i])
                }
                return params;
            },
            getMenuButton(level1, level2) {
                let menu = JSON.parse(window.sessionStorage.getItem('menu'));
                let menuLen = menu.length;
                for (let i = 0; i < menuLen; i++) {
                    if (menu[i].name == level1) {
                        let child = menu[i].childList;
                        let childLen = child.length;
                        for (let j = 0; j < childLen; j++) {
                            if (child[j].name == level2) {
                                let ids = child[j].childList;
                                let idLen = ids.length
                                let arr = []
                                for (let m = 0; m < idLen; m++) {
                                    arr.push(ids[m].id)
                                }
                                return arr
                            }
                        }
                    }
                }
            },
            timeChange: function (time, type) {
                if (!time) {
                    return ''
                }
                var br = " ";
                if (type == 1) {
                    br = "<br/>"
                }
                var str = "";
                var t = new Date(time)
                str += t.getFullYear() + "-"
                str += a(t.getMonth() + 1) + "-"
                str += a(t.getDate()) + br
                str += a(t.getHours()) + ":"
                str += a(t.getMinutes()) + ":"
                str += a(t.getSeconds())

                function a(t) {
                    if (t > 9) {
                        return t;
                    } else {
                        return "0" + t
                    }
                }
                if (type == 2) {
                    str = str.substr(0, 10)
                }
                return str;
            },
            //*   1、moneyChange(time,type)金额转换成每三位加一个点
            moneyChange: function (money) {
                money = money + ""
                if (money.length <= 3) {
                    return money
                }
                var arr = money.split(".")[0].split("");
                var newarr = [];
                for (var i = (arr.length - 1), j = 1; i >= 0; i-- , j++) {
                    newarr.unshift(arr[i])
                    if (j % 3 == 0 && i != 0) {
                        newarr.unshift(",")
                    }
                }
                if (money.split(".").length > 1) {
                    return newarr.join("") + "." + money.split(".")[1];
                } else {
                    return newarr.join("")
                }
            },
            //*   2、check(str,type) 格式校验函数 str为待检测字符串 type为待检测类型
            check: function (str, type) {
                if (type == "phone") {
                    if ("/^1[34578]\d{9}$/".test(str)) {
                        return true
                    }
                }
                if (type == "name") {
                    if (str.length < 6 && str.length > 1) {
                        return true
                    }
                }
                if (type == "password") {
                    if (str.length < 6) {
                        return true
                    }
                }
                if (type == "email") {
                    if ("/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/".test(str)) {
                        return true
                    }
                }
                if (type == "jobNum") {
                    if (str.length == 6) {
                        return true
                    }
                }
                if (type == "plus") {
                    if (parseInt(str) > 0) {
                        return true
                    }
                }
                return false;
            },
            //*   3、dateComplate(str,type) 时间格式转换函数 str为需要转换的数字
            dateComplate: function (t) {
                if (t > 9) {
                    return t;
                } else {
                    return "0" + t
                }
            },
            /*==============处理网络请求类==============*/
            //*   4、ajax(arr,fn) AJAX函数 url为请求地址，type为请求类型，data为请求类型，fn 为处理正确返回值的函数
            ajax: function (url, type, datas, fn) {
                if (url == undefined || type == undefined) { //如果url,type都没有，直接返回
                    return
                }
                if (type == "post" && datas == undefined) { //如果type为post,datas为空，直接返回
                    return
                }
                var baseUrl = "http://192.168.21.188:9000";
                var params = {};
                var data = {};
                if (type == "get") { //get请求
                    if (datas != undefined) { //get请求可以没有请求体

                        params = datas;
                    }
                }
                if (type == "post" && datas != undefined) { //post请求
                    data = datas;
                }
                Vue.axios({
                    method: type,
                    url: baseUrl + url,
                    params: params,
                    data: data
                })
                    .then(function () {
                        if (fn != undefined) {
                            fn(arguments)
                        }
                    })
                    .catch(function () { })
            },
            /*==============处理省市县三联动类==============*/
            //*   5、getAreaList() 获取省市县列表
            getAreaList: function (fn) {
                if (localStorage.getItem("arealist")) {
                    fn(localStorage.getItem("arealist"))
                } else {
                    Vue.axios({ //查询省市县
                        url: "http://api.hc.foodiekitty.cc/api/v1/config/getAreaConfig"
                    })
                        .then(function (date) {
                            fn(date.data.data)
                            localStorage.setItem("arealist", JSON.stringify(date.data.data))
                        })
                }
            },
            //*   6、provinceChange(areaList,index,cityList)省份变化函数 areaList为省市县列表，index为索引，cityLis为城市列表
            provinceChange: function (areaList, index, cityList) {
                cityList = areaList[index].cites
            },
            //*   7、cityChange(cityList,index,countyList)城市变化函数 cityList为市县列表，index为索引，countyList为城市列表
            cityChange: function (cityList, index, countyList) {
                countyList = cityList[index].areas
            },
            //*   8、运营平台获取地区列表
            operatioGetArea() {
                var _self = this;
                if (localStorage.getItem("oarealist")) {

                } else {
                    Vue.axios({
                        url: "http://api.hc.foodiekitty.cc/api/v1/config/getAreaConfig",
                    }).then((res) => {
                        localStorage.setItem("oarealist", JSON.stringify(res.data.data))
                    })
                }
            },
            //判断字符串里的字符是否全部是数字类型
            checkNumber(theObj) {
              var reg = /^[0-9]+$/;
              if(Object.prototype.toString.call(theObj) == "[object String]"){
                theObj = theObj.replace(/(^\s*)|(\s*$)/g, "");
              }
              if(theObj){
                if (reg.test(theObj)) {
                  return true;
                }else{
                  return false;
                }
              }else{
                return true
              }
            },
            //对象和数组的深拷贝
            deepCopy(obj) {
              // 创建一个新对象
              let result = {}
              let keys = Object.keys(obj),
                  key = null,
                  temp = null;
              for (let i = 0; i < keys.length; i++) {
                  key = keys[i];
                  temp = obj[key];
                  // 如果字段的值也是一个对象则递归操作
                  if (temp && typeof temp === 'object') {
                      result[key] = this.deepCopy(temp);
                  } else {
                  // 否则直接赋值给新对象
                      result[key] = temp;
                  }
              }
              return result;
            },
            //清空一个对象里所有属性值
            clearData(obj){//清空数据
              if(Object.prototype.toString.call(obj) === '[object Object]'){
                let arrKeys = Object.keys(obj)
                for(let val of arrKeys){//重置查询条件
                  obj[val] = ""
                }
              }
            },
            formateTimeTo(obj){
              if(obj.startTime){
                obj.startTime = new Date(obj.startTime).getTime()
              }
              if(obj.endTime){
                obj.endTime = new Date(obj.startTime).getTime()
              }
              return obj
            },
            /**
            * 数组元素交换位置
            * @param {array} arr 数组
            * @param {number} index1 添加项目的位置
            * @param {number} index2 删除项目的位置
            * index1和index2分别是两个数组的索引值，即是两个要交换元素位置的索引值，如1，5就是数组中下标为1和5的两个元素交换位置
            */
            swapArray(arr, index1, index2) {
              arr[index1] = arr.splice(index2, 1, arr[index1])[0];
              console.log(arr)
              return arr;
            },

            //上移 将当前数组index索引与后面一个元素互换位置，向数组后面移动一位
            moveUp(arr,index,length){
              if(index != 0){
                this.swapArray(arr, index, index-1);
              }else{
                $Message.info('已经处于置顶，无法上移');
              }
            },

            //下移 将当前数组index索引与前面一个元素互换位置，向数组前面移动一位
            moveDown(arr,index,length){
              if(index!= length - 1){
                this.swapArray(arr, index, index+1);
              }else{
                $Message.info('已经处于置底，无法下移');
              }
            },
             //格式化数据
            format: function(value, type) {
              //保留两位小数(正数)
              if (type == "keepTwoDecimal") {
                //修复第一个字符是小数点 的情况.
                if (value != "" && value.substr(0, 1) == ".") {
                  value = "";
                }
                value = value.replace(/[^\d.]/g, ""); //清除“数字”和“.”以外的字符
                value = value.replace(/\.{2,}/g, "."); //只保留第一个. 清除多余的
                value = value
                  .replace(".", "$#$")
                  .replace(/\./g, "")
                  .replace("$#$", ".");
                value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, "$2.$3"); //只能输入两个小数
                if (value.indexOf(".") < 0 && value != "") {
                  let length=value.length;
                  for(let i=0; i<length; i++){
                    if (value.substr(0, 1) == "0" && value.length >= 2) {
                      value = value.substr(1, value.length);
                    }
                  }
                }
                return value;
              }

              //正整数
              if (type == "positiveInteger") {
                if (!value) {
                  return;
                }
                value =  value.replace(/\D/g, "");
                let length=value.length;
                  for(let i=0; i<length; i++){
                    if (value.substr(0, 1) == "0") {
                      value = value.substr(1, value.length);
                    }
                  }
                return value;
              }

              //整数
              if (type == "integer") {
                if (!value) {
                  return;
                }
                value = value.replace(/\D/g, "");
                let length=value.length;
                for(let i=0; i<length; i++){
                  if (value.substr(0, 1) == "0" && value.length >= 2) {
                    value = value.substr(1, value.length);
                  }
                }
                return value;
              }

              //数字,小数不限制，可以是负数
              if (type == "number") {
                if (value != "" && value.substr(0, 1) == ".") {
                  value = "";
                }
                value = value.replace(/[^-\d.]/g, "");
                value = value.replace(/\.{2,}/g, ".");
                value = value
                  .replace(".", "$#$")
                  .replace(/\./g, "")
                  .replace("$#$", ".");
                value = value
                  .replace("-", "$#$")
                  .replace(/\-/g, "")
                  .replace("$#$", "-");
                let prefix="";
                if(value.substr(0, 1) == "-"){
                  prefix = "-";
                  value = value.substr(1,value.length);
                }
                if (value.indexOf(".") < 0 && value != "") {
                  let length=value.length;
                  for(let i=0; i<length; i++){
                    if (value.substr(0, 1) == "0" && value.length >= 2) {
                      value = value.substr(1, value.length);
                    }
                  }
                }
                return prefix+value;
              }
              return value;
            }
            //*   8、运营平台获取地区列表
            // operatioGetArea:function(){
            //   var _self = this;
            //   if (localStorage.getItem("oarealist")) {
            //
            //   } else {
            //     Vue.axios({
            //       url: "http://api.hc.foodiekitty.cc/api/v1/config/getAreaConfig",
            //     }).then(function(res){
            //       localStorage.setItem("oarealist", JSON.stringify(res.data.data))
            //     })
            //   }
            // }
        }
    }
}
